
const Loading = () => {
  return (
    <div className="d-flex justify-content-center">
      <div className="spinner-border" role="status">
        <span className="sr-only" data-testid="loading">Loading...</span>
      </div>
    </div>
  );
};

export default Loading;
